import React, {useEffect, useState} from 'react';
import {makeStyles} from "@mui/styles";
import {Theme} from "@mui/material";
import {IntegrationMenu} from "../../constants/AppConstants"
import {Link, useHistory, useLocation, useParams} from "react-router-dom";
import {pathParams} from "path-params";
import {useIntegrationsContext} from "../../api/integrations/IntegrationsContext";
import {showError} from "../../utils/NotificationUtils";
import {IntegrationItemProps} from "../../api/integrations/IntegrationsDTO";
import EditIcon from '@mui/icons-material/Edit';
import cx from "classnames"
import {Routes} from "../../constants/Routes";
const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: 300,
        borderRight: `1px solid #EBEEFB`,
        background: theme.palette.common.white,
        transition: "0.3s",
        overflow: "hidden",
    },
    item: {
        width: "100%",
        height: theme.typography.pxToRem(48),
        padding: theme.typography.pxToRem(12),
        display: "flex",
        alignItems: "center",
        borderBottom: "1px solid #EBEEFB",
    },
    active: {
        background: "#3F51B5",
        color: "#fff !important" as any,
    },
    title: {
        transition: "0.3s",
        "& span": {
            color: theme.palette.primary.main,
        }
    },
    link: {
        "&:active": {
            color: "#3F51B5"
        }
    },
    integrationInfoRoot: {
        display: "flex",
        alignItems: "center",
        borderBottom: "1px solid #EBEEFB",
        overflow: "hidden",
        gap: 10,
        padding: 10
    },
    logoRoot: {
        minWidth: 60,
        maxWidth: 60,
        height: 60,
        background: "#EBEEFB",
        padding: 5,
        borderRadius: 10,
        position: "relative",
        "&:hover .integrationEdit": {
            opacity: 1,
            visibility: "visible",
            pointerEvents: "all"
        },
        "& img": {
            width: "100%",
            height: "100%",
            objectFit: "contain"
        }
    },
    integrationEdit: {
        position: "absolute",
        width: "100%",
        height: '100%',
        top: 0,
        left: 0,
        display: "flex",
        alignItems: "center",
        background: "#FFF",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        pointerEvents: "none",
        cursor: "pointer",
        border: "2px solid",
        borderRadius: 10,
        transition: "0.3s"
    }
}));


export function IntegrationsSidebar() {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const params: any = useParams();
    const {IntegrationsApi} = useIntegrationsContext();
    const [data, setData] = useState<IntegrationItemProps>();

    useEffect(() => {
        IntegrationsApi.getIntegrationById({params: {id: params.id}}).then(res => {
            setData(res.payload)
        }).catch(err => {
            showError(err)
        })
    }, [IntegrationsApi, params]);

    return (
        <div className={classes.root}>
            <ul>
                {data && (
                    <li className={classes.integrationInfoRoot}>
                        <div className={classes.logoRoot}>
                            <img src={data.logoUrl} alt=""/>
                            <div className={cx(classes.integrationEdit, "integrationEdit")} onClick={() => {
                                history.push(pathParams(Routes.IntegrationEdit, {id: data.id}))
                            }}>
                                <EditIcon />
                            </div>
                        </div>
                        <div>
                            <h3>{data.name}</h3>
                        </div>
                    </li>
                )}
                {IntegrationMenu.map((item, index) => {
                    return (
                        <Link key={index} to={pathParams(item.link, {id: params.id})} className={classes.link}>
                            <li
                                className={cx(
                                    classes.item,
                                    location.pathname.includes(pathParams(item.link, {id: params.id}))
                                    && classes.active)}>
                                <span className={classes.title}>{item.title}</span>
                            </li>
                        </Link>
                    )
                })}
            </ul>
        </div>
    );
}

